import { forwardRef } from 'react';

import KnownIssueErrorBoundary from 'my-components/KnownIssueErrorBoundary';

import Editor from './Editor';

const EditorError = forwardRef(function EditorError(props, ref) {
  return (
    <KnownIssueErrorBoundary errorSource="draftjs-editor">
      <Editor ref={ref} {...props} />
    </KnownIssueErrorBoundary>
  );
});

export default EditorError;
